'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promisedFileReader = require('../file/promisedFileReader');

var _getExifOrientationData = require('./getExifOrientationData');

var _getExifOrientationData2 = _interopRequireDefault(_getExifOrientationData);

var _mimeConstants = require('../../../../common/media/mimeConstants');

var _jpegExifOrientationTransformer = require('./jpegExifOrientationTransformer');

var _jpegExifOrientationTransformer2 = _interopRequireDefault(_jpegExifOrientationTransformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
// Utils
var ORIENTATIONS_REQUIRING_TRANSFORMATIONS = [2, 3, 4, 5, 6, 7, 8];

// JPEG EXIF Orientation


var orientationRequiresTransformation = function orientationRequiresTransformation(orientation) {
    return ORIENTATIONS_REQUIRING_TRANSFORMATIONS.indexOf(orientation) !== -1;
};

exports.default = function (inputFile) {
    // If not a JPEG file then we don't need to worry about
    if (inputFile.type !== _mimeConstants.MIME_TYPES.JPEG) {
        return (0, _promisedFileReader.readAsDataURL)(inputFile).then(function (imageDataUri) {
            return { file: inputFile, imageDataUri: imageDataUri };
        });
    }

    return (0, _getExifOrientationData2.default)(inputFile).then(function (srcOrientation) {
        return (0, _promisedFileReader.readAsDataURL)(inputFile).then(function (imageDataUri) {
            return { file: inputFile, imageDataUri: imageDataUri, srcOrientation: srcOrientation };
        });
    }).then(function (_ref) {
        var file = _ref.file,
            imageDataUri = _ref.imageDataUri,
            srcOrientation = _ref.srcOrientation;
        return orientationRequiresTransformation(srcOrientation) ? (0, _jpegExifOrientationTransformer2.default)({ srcOrientation: srcOrientation, imageDataUri: imageDataUri }) : { file: file, imageDataUri: imageDataUri };
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/image/imageFileLoader.js
// module id = 766
// module chunks = 0